import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import { watchAuthState } from "../../services/authService";
import { getUserProfileByUid } from "../../services/userProfileService";

const TIMEOUT_MS = 15000;

const AuthLoadingPage = () => {
  const navigate = useNavigate();
  const resolved = useRef(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      if (!resolved.current) {
        resolved.current = true;
        navigate("/login", { replace: true });
      }
    }, TIMEOUT_MS);

    const unsubscribe = watchAuthState(async (user) => {
      if (resolved.current) return;

      if (!user) {
        resolved.current = true;
        navigate("/login", { replace: true });
        return;
      }

      try {
        const profile = await getUserProfileByUid(user.uid);

        if (!profile || !profile.role) {
          // 프로필 미완성 (소셜 로그인 후 가입 안 함) → 전화번호 인증으로
          resolved.current = true;
          navigate("/phone-verify", { replace: true, state: { fromSocial: true } });
          return;
        }

        if (profile.status === "approved") {
          resolved.current = true;
          navigate("/home", { replace: true });
        } else {
          resolved.current = true;
          navigate("/login", {
            replace: true,
            state: { toast: "승인 대기중입니다. 관리자 승인 후 이용 가능합니다." },
          });
        }
      } catch (err) {
        console.error("프로필 확인 실패:", err);
        resolved.current = true;
        navigate("/login", { replace: true });
      }
    });

    return () => {
      clearTimeout(timer);
      unsubscribe();
    };
  }, [navigate]);

  return (
    <Container>
      <Spinner />
      <Text>로그인 확인 중...</Text>
    </Container>
  );
};

export default AuthLoadingPage;

const Container = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: #f5f7fa;
  gap: 16px;
`;

const Spinner = styled.div`
  width: 40px;
  height: 40px;
  border: 4px solid #e0e0e0;
  border-top-color: #4db6ac;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
  @keyframes spin {
    to { transform: rotate(360deg); }
  }
`;

const Text = styled.p`
  font-size: 15px;
  color: #666;
`;
